import { GraphQLClient } from 'graphql-request';

export const graphqlClient = new GraphQLClient(process.env.REACT_APP_SNAPSHOT_GRAPHQL_ENDPOINT, {
  //   headers: { 'content-type': 'application/json' },
});
